<div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
  
  <div id="scanner-container">
    <!-- QuaggaJS will populate this element -->
  </div>
  
  <div class="controls">
    <form>
      <input id="acceptAnyCode" type="checkbox" [(ngModel)]="acceptAnyCode" name="acceptAnyCode" required/>
      <label for="acceptAnyCode">Accept any code</label>
      &nbsp;
      <button (click)="clearCart()">{{ 'clear_cart' | translate }}</button>
    </form>
  
  </div>
  
  <div class="shopping-cart">
  
    <span *ngIf="items.length === 0 else shoppingCartItems">{{ 'count_is_empty' | translate }}</span>
    <ng-template #shoppingCartItems>
  
      <app-item
        *ngFor="let articleAndCount of items"
        [article]="articleAndCount[0]"
        [count]="articleAndCount[1]">
      </app-item>
  
      <div class="shopping-cart-total">
        Total: {{ totalPrice }} USD
      </div>
    </ng-template>
  </div>
  